module.exports = __webpack_public_path__ + "img/enca-grey.cd54c9d6.png";